<template>
  <div class="button-group">
    <button class="btn btn-sm btn-success" @click="modificar">Modificar</button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ContratosTablaActions",
  methods: {
    modificar() {
      this.$router.push(
        `/admin/clientes/${this.params.data.id_cliente}/contratos/${this.params.data.id_contrato}`,
      );
    },
  },
});
</script>

<style scoped></style>
